import { useEffect, useState } from 'react';
import { useAppSelector } from '../../Reducers/store';
import { SitePage } from '../../Models/SitePage';
import SitePageApi from '../../Api/SitePageApi';
import { PageType } from '../../Enums/PageType';
import { renderHTML } from '../../Utils';
import Loader from '../Common/Loader';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Carousel, TextInput } from 'flowbite-react';
import CommonApi from '../../Api/CommonApi';
import { toast } from 'react-toastify';
import { File as ImageFile } from '../../Models/File';
import { MdCategory, MdFactory } from 'react-icons/md';
import { BsFillNutFill } from 'react-icons/bs';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import { SearchRequest } from '../../Models/SearchRequest';
// import './index.css';

export default function Dashboard() {
  const navigate = useNavigate();
  const { userModel } = useAppSelector((state) => state.user);
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem('searchTextState') ?? '',
    searchPartsText: localStorage.getItem('searchPartsText') ?? '',
    manufacturers: null,
    categories: null,
    subCategories: null,
    minPrice: null,
    maxPrice: null,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 1,
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '1');
    localStorage.setItem('searchTextState', formData.searchText ?? '');
    setFormData((prevData) => ({ ...prevData, searchText: '' }));
    navigate('/products/search');
  };
  useEffect(() => {
    //   getSitePages();
    checkUpdateOpenOrder();
    getSitePage();
  }, []);

  useEffect(() => {
    if (pageData) {
      getSitePageFile();
    }
  }, [pageData]);

  const getSitePage = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageByPageType(PageType.HomePage.toString())
        .then((res) => {
          setPageData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const getSitePageFile = () => {
    try {
      setIsLoading(true);
      if (pageData) {
        return CommonApi.GetFilesBySitePage(pageData?.id)
          .then((res) => {
            if (res.data !== null) {
              setImageFiles(res.data as ImageFile[]);
            }
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handlePartsClick = () => {
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '2');
    setFormData((prevData) => ({
      ...prevData,
      searchText: '',
      equipmentType: 2,
    }));
    setTimeout(() => {
      navigate('/products/search/parts', { replace: true });
    }, 100);
  };

  const checkUpdateOpenOrder = async () => {
    if (userModel) {
      let openOrderId = 0;
      await OrderApi.checkUserOpenOrder(userModel.id)
        .then((res) => {
          if (res.data) {
            openOrderId = res.data.id;
            localStorage.setItem('openOrderId', openOrderId.toString());
          } else {
            const newOrder: Order = {
              id: 0,
              businessName: null,
              contactName: null,
              contactPhone: null,
              contactEmail: null,
              notes: null,
              dateCreated: null,
              orderStatusId: 1,
              userId: userModel.id,
              billingAddressId: null,
              shippingAddressId: null,
              orderItems: [],
              billingAddress: null,
              shippingAddress: null,
              dateSubmitted: null,
              ponumber: null,
              clientId: userModel.clientId,
              shippingMethodId: null,
              client: null,
              user: null,
            };
            OrderApi.addUpdateOrder(newOrder)
              .then((res) => {
                if (res.data.success) {
                  openOrderId = Number(res.data.affectedEntityIdentifier);
                  localStorage.setItem('openOrderId', openOrderId.toString());
                }
              })
              .catch((err) => {
                setIsLoading(false);
              });
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem('orderItemsCount', res.data.toString());
            window.dispatchEvent(new Event('updateOrderItemCount'));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className='w-full'>
      <div className='relative w-full h-full text-center flex flex-col justify-between'>
        {isLoading && <Loader />}
        <div className='bg-mainBackground'>
          {pageData && imageFiles && imageFiles.length > 0 && (
            <div className='w-full mx-auto h-56 sm:h-64 xl:h-72 2xl:h-80'>
              <Carousel
                slide={true}
                className=''
                slideInterval={5000}
                indicators={false}
              >
                {imageFiles.map((data) => (
                  <div
                    key={data.id}
                    className='group flex flex-col w-full mx-auto object-contain h-56 sm:h-64 xl:h-72 2xl:h-80'
                  >
                    <img
                      src={data.fileUrl!}
                      alt={pageData.title + '-image'}
                      className='object-cover h-56 sm:h-64 xl:h-72 2xl:h-80'
                    />
                    {/* <div className='hidden group-hover:block absolute content-end w-full h-full px-20 bg-black/50 text-white'>
                    <div className=''>Test</div>
                  </div> */}
                  </div>
                ))}
              </Carousel>
            </div>
          )}

          <div className='w-full py-10 hidden sm:block'>
            <form onSubmit={onSubmit} className='flex ms-20 me-20'>
              <TextInput
                id='searchText'
                name='searchText'
                type='text'
                placeholder='Search Wholegoods by Number, Model, or Description..'
                onChange={handleChange}
                value={formData.searchText ?? ''}
                className='w-full pr-1'
                sizing={'lg'}
              />
              <Button type='submit' className='buttonMain ' size={'xl'}>
                <span className='text-xl'>Search</span>
              </Button>
            </form>
          </div>
        </div>
        <div className='m-4 p-4 border-b-2'>
          {pageData?.description && renderHTML(pageData?.description)}
        </div>
        <div className='flex text-lg sm:text-3xl font-bold h-20 sm:h-40'>
          <Link
            to={'/products/manufacturers'}
            className='flex w-1/3 bg-black text-white h-full'
          >
            <div className='m-auto'>
              <div className='w-full flex justify-center '>
                <MdFactory />
              </div>
              <div className=''>Manufacturers</div>
            </div>
          </Link>

          <Link
            to={'/products/categories'}
            className='flex w-1/3 bg-mainBackground h-full'
          >
            <div className='m-auto'>
              <div className='w-full flex justify-center'>
                <MdCategory />
              </div>
              <div>Wholegoods</div>
            </div>
          </Link>
          <div
            onClick={handlePartsClick}
            className='flex w-1/3 bg-black text-white h-full cursor-pointer'
          >
            <div className='m-auto'>
              <div className='w-full flex justify-center'>
                <BsFillNutFill />
              </div>
              <div>Parts</div>
            </div>
          </div>
        </div>
        {/* <div className='flex flex-col m-4 mt-4 mx-auto p-4 w-3/4 lg:w-1/2 justify-center text-md lg:text-xl border-2'>
          <div className='text-left mb-2'>Join Our Newsletter</div>
          <form className='w-full flex justify-between'>
            <div className='my-auto'>Email:</div>
            <div className='w-3/4'>
              <TextInput
                id='email'
                name='email'
                type='text'
                placeholder='your@email.com...'
                // onChange={handleChangeInput}
                // value={formData.upc ?? ''}
                sizing='md'
              />
            </div>
            <div>
              <Button
                disabled={buttonDisabled}
                type='submit'
                className='buttonMain'
              >
                Join
              </Button>
            </div>
          </form>
        </div> */}
      </div>
    </div>
  );
}
